module.exports = __webpack_public_path__ + "assets/img/aea76b629f967d6daa7aa3809e81548f.svg";